export default __webpack_public_path__ + "static/media/refreshNew.936e9b66.svg";